export default __webpack_public_path__ + "images/b32f821ee378430e678b9aa7e9e0715b.png";